const FAVICON_REL = 'shortcut icon';
const FAVICON_TYPE = 'image/x-icon';

/**
 * Adds or Replaces the favicon
 * @param favIconUrl The url to be given for fav icon
 */
export function applyFavicon(favIconUrl: string) {
    if (!document) {
        return;
    }

    let favIconElement = document.querySelector(`link[rel="${FAVICON_REL}"]`) as HTMLLinkElement;

    if (!favIconElement) {
        favIconElement = document.createElement('link');
        favIconElement.rel = FAVICON_REL;
        favIconElement.type = FAVICON_TYPE;

        document.head.appendChild(favIconElement);
    }

    favIconElement.href = favIconUrl;
}
